/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface ReferencedOrganisationDTO
 */
export interface ReferencedOrganisationDTO  {
    /**
     * 
     * @type {number}
     * @memberof ReferencedOrganisationDTO
     */
    id?: number;
    /**
     * 
     * @type {Date}
     * @memberof ReferencedOrganisationDTO
     */
    endDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof ReferencedOrganisationDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferencedOrganisationDTO
     */
    note?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferencedOrganisationDTO
     */
    oldId?: string;
    /**
     * 
     * @type {Date}
     * @memberof ReferencedOrganisationDTO
     */
    startDate?: Date;
    /**
     * 
     * @type {Array<string>}
     * @memberof ReferencedOrganisationDTO
     */
    topOrgas?: Array<string>;
}

/**
 * Check if a given object implements the ReferencedOrganisationDTO interface.
 */
export function instanceOfReferencedOrganisationDTO(value: object): value is ReferencedOrganisationDTO {
    return true;
}

export function ReferencedOrganisationDTOFromJSON(json: any): ReferencedOrganisationDTO {
    return ReferencedOrganisationDTOFromJSONTyped(json, false);
}

export function ReferencedOrganisationDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferencedOrganisationDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
                  'name': json['name'] == null ? undefined : json['name'],
                  'note': json['note'] == null ? undefined : json['note'],
                  'oldId': json['oldId'] == null ? undefined : json['oldId'],
                'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
              'topOrgas': json['topOrgas'] == null ? undefined : json['topOrgas'],
    };
}

export function ReferencedOrganisationDTOToJSON(json: any): ReferencedOrganisationDTO {
    return ReferencedOrganisationDTOToJSONTyped(json, false);
}

export function ReferencedOrganisationDTOToJSONTyped(value?: ReferencedOrganisationDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'endDate': value['endDate']?.toISOString(),
        'name': value['name'],
        'note': value['note'],
        'oldId': value['oldId'],
        'startDate': value['startDate']?.toISOString(),
        'topOrgas': value['topOrgas'] == null? value['topOrgas']: value['topOrgas'],
    };
}


